import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'

// Your web app's Firebase configuration
var firebaseConfig = {
  apiKey: "AIzaSyDANyEkesM_8crpm7IsQHU68L6VuCYNPd8",
  authDomain: "mathsclubsastra-ca494.firebaseapp.com",
  databaseURL: "https://mathsclubsastra-ca494.firebaseio.com",
  projectId: "mathsclubsastra-ca494",
  storageBucket: "",
  messagingSenderId: "742164746612",
  appId: "1:742164746612:web:c6f491914f110756"
};
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);
  //firebase.firestore().settings({ timestampsInSnapshots: true});

  export default firebase;